import type { ReactNode } from "react";

interface SectionViewProps {
  title?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}

/**
 * Standard page-section layout: optional heading row with left title +
 * right-aligned actions, followed by the section body. The heading row
 * collapses if both title and actions are absent.
 */
export function SectionView({ title, actions, children }: SectionViewProps) {
  const showHeader = title != null || actions != null;
  return (
    <div className="flex flex-col gap-4">
      {showHeader ? (
        <header className="flex min-h-7 items-center justify-between">
          <div className="type-heading text-foreground">{title}</div>
          {actions ? (
            <div className="flex items-center gap-1">{actions}</div>
          ) : null}
        </header>
      ) : null}
      {children}
    </div>
  );
}
